// El Sistema de Rachas.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Sistema de Rachas (Streak Charge) ----

export const getStreak = () => api.get("/streak").then((r) => r.data);
export const pingStreak = () => api.post("/streak/ping").then((r) => r.data);
